// API Configuration for Migpath Backend
import { BASE_URL } from '../constants';

const API_CONFIG = {
  // Use centralized BASE_URL from constants.js
  BASE_URL: process.env.REACT_APP_API_URL || BASE_URL,
  
  ENDPOINTS: {
    SUBMIT_PAYMENT_REQUEST: '/payment-request',
    AUTOMATE_PAYMENT: '/automate-checkout',
    GET_PAYMENT_STATUS: '/status',  // Updated endpoint path
    LIST_PAYMENT_REQUESTS: '/payment-requests'
  }
};

// Helper function to build full API URLs
export const getApiUrl = (endpoint) => {
  return `${API_CONFIG.BASE_URL}${endpoint}`;
};

// API service functions
export const apiService = {
  // Submit payment request
  submitPaymentRequest: async (userData) => {
    const response = await fetch(getApiUrl(API_CONFIG.ENDPOINTS.SUBMIT_PAYMENT_REQUEST), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(userData)
    });
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to submit payment request');
    }
    
    return response.json();
  },

  // Trigger payment automation
  automatePayment: async (requestId) => {
    const response = await fetch(getApiUrl(API_CONFIG.ENDPOINTS.AUTOMATE_PAYMENT), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ requestId })
    });
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Payment automation failed');
    }
    
    return response.json();
  },

  // Get payment status
  getPaymentStatus: async (requestId) => {
    const response = await fetch(getApiUrl(`${API_CONFIG.ENDPOINTS.GET_PAYMENT_STATUS}/${requestId}`), {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      }
    });
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to get payment status');
    }
    
    return response.json();
  },

  // Get payment requests with filtering and pagination
  getPaymentRequests: async (options = {}) => {
    const params = new URLSearchParams();
    
    if (options.page) params.append('page', options.page.toString());
    if (options.limit) params.append('limit', options.limit.toString());
    if (options.status) params.append('status', options.status);
    if (options.search) params.append('search', options.search);
    if (options.dateRange) params.append('dateRange', options.dateRange);
    
    const url = `${getApiUrl(API_CONFIG.ENDPOINTS.LIST_PAYMENT_REQUESTS)}?${params.toString()}`;
    
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      }
    });
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to get payment requests');
    }
    
    return response.json();
  },

  // List payment requests (legacy method - keeping for backward compatibility)
  listPaymentRequests: async (status = null, limit = 50) => {
    const params = new URLSearchParams();
    if (status) params.append('status', status);
    if (limit) params.append('limit', limit.toString());
    
    const url = `${getApiUrl(API_CONFIG.ENDPOINTS.LIST_PAYMENT_REQUESTS)}?${params.toString()}`;
    
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      }
    });
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to list payment requests');
    }
    
    return response.json();
  }
};

export default API_CONFIG;
